import { createAsyncThunk } from '@reduxjs/toolkit';
import type OfferCodeApi from 'api/digifi/application/OfferCodeApi';
import { DEBOUNCE_TIMEOUT } from 'thunks/thunks.config';
import debounce from 'utils/debounce';

export const createGetOfferCodeDataThunk = (api: OfferCodeApi) => {
  const debouncedApiCall = debounce(
    (data: { userId: string }) => api.getOfferCodeDataByUserId(data.userId),
    DEBOUNCE_TIMEOUT,
  );

  return createAsyncThunk('offer-code/get-offer-code-data', async (data: { userId: string }) => {
    try {
      return await debouncedApiCall(data);
    } catch (error) {
      throw error;
    }
  });
};
